import * as yup from 'yup'
import { judgeOpts } from '@ow/utils'

export default function (opts, fields, data, refConditonFields) {
  let finalOpts = {}
  console.log(
    refConditonFields,
    refConditonFields[opts.slug],
    opts,
    'refControl'
  )
  if (opts.logicSpec && refConditonFields[opts.slug]) {
    // 添加监听
    const logicFields = opts.logicSpec.conditions.map((x) => x.slug)
    console.log(refConditonFields[opts.slug], logicFields, 'logicFields')
    finalOpts = judgeOpts({
      opts,
      values: refConditonFields[opts.slug],
      fields,
      defaultValues: data,
    })
    console.log(finalOpts, 'finalOpts')
  } else {
    finalOpts = opts
  }
  // const { required, type } = finalOpts
  // console.log(finalOpts, 'finalOpts2')
  const { required, multiple, minlen, maxlen, rangeSetting } = finalOpts

  let schema = yup.array().nullable()
  if (required) {
    schema = schema.required('这是一个必填项')
  }
  if (required && rangeSetting && multiple && minlen) {
    schema = schema.min(minlen, `至少选择${minlen}个选项`)
  }
  if (required && !multiple) {
    schema = schema.min(1, '这是一个必填项')
  }
  if (multiple && rangeSetting && maxlen) {
    schema = schema.max(maxlen, `最多选择${maxlen}个选项`)
  }

  return schema
}
